import React from 'react'
import PropTypes from 'prop-types'

const UserdataSection = ({ title, data }) => (

  <div>
    <h4>{title}</h4>
    <table className='mt-3 mb-3'>
      <tbody>
        <tr>
          <td className='td_label'>Name:</td>
          <td>{data.shippingAddress.first_name} {data.shippingAddress.last_name}</td>
        </tr>
        <tr>
          <td className='td_label'>Street:</td>
          <td>{data.shippingAddress.street}</td>
        </tr>
        <tr>
          <td className='td_label'>Town:</td>
          <td>{data.shippingAddress.city}</td>
        </tr>
        <tr>
          <td className='td_label'>ZIP:</td>
          <td>{data.shippingAddress.zip}</td>
        </tr>
        <tr>
          <td className='td_label'>E-mail:</td>
          <td>{(data.shippingAddress.email ? data.shippingAddress.email : data.personal.email)}</td>
        </tr>
        <tr>
          <td className='td_label'>Phone:</td>
          <td>{(data.shippingAddress.phone ? data.shippingAddress.phone : data.personal.phone)}</td>
        </tr>
      </tbody>
    </table>
  </div>
)

UserdataSection.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired
}

export default UserdataSection



// WEBPACK FOOTER //
// ./src/molecules/components/UserPersonalSection.js